module.exports = __webpack_public_path__ + "static/media/Alert_Graphic.0492e7a1.png";